import axios from 'axios';

export default function () {
  // функционал отложенной загрузки чтобы спрятать блок от индексации
  const hideSEOItems = document.querySelectorAll('.js-load-hide-seo-content');

  if (hideSEOItems.length > 0) {
    setTimeout(() => {
      hideSEOItems.forEach((item) => {
        const hideSEOUrl = item.dataset.seoUrl;

        if (hideSEOUrl) {
          axios
              .get(hideSEOUrl)
              .then((res) => {
                item.insertAdjacentHTML('afterbegin', res.data);
              });
        }
      });
    }, 500);
  }
  // конец
}